import EventBus from 'diagram-js/lib/core/EventBus';
import Canvas from "diagram-js/lib/core/Canvas";
import {markers} from "@ispm-client/modules/bpmn-modeler/constants/constants";
import {EventType} from "@ispm/shared/bpmn-io/bpmn-js";


export class AddConnectionOutBehavior {


    constructor(private eventBus: EventBus, private canvas: Canvas) {
        this.addOnConnectionOut();
    }

    private addOnConnectionOut() {

        this.eventBus.on([EventType.CONNECT_OUT, EventType.CONNECT_CLEANUP], 10000, event => {
            const context = event.context;

            if (context.target) {
                this.canvas.removeMarker(context.target, markers.MARKER_NOT_OK);
                this.canvas.removeMarker(context.target, markers.MARKER_OK);
            }
        });
    }
}
